<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">百度爱采购</div>
        <div class="type">
          一站式满足客户需求，真正帮助企业解决【卖货】营销难题
        </div>
      </div>
      <div class="float">
        <img
          src="http://gxbg.pangodso.com/file/aicaigou_img1.png"
          alt=""
          class="center"
        />
        <div class="out" style="left: -60%; top: 40px">
          <img
            src="http://gxbg.pangodso.com/file/aicaigou_img2.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">专属企业名片</div>
            <div class="desc">百度认证，权威展现</div>
          </div>
        </div>
        <div class="out" style="right: -52%; top: 40px">
          <img
            src="http://gxbg.pangodso.com/file/aicaigou_img3.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">多终端阵地</div>
            <div class="desc">一次入驻，全网触达</div>
          </div>
        </div>
        <div class="out" style="left: -60%; bottom: 140px">
          <img
            src="http://gxbg.pangodso.com/file/aicaigou_img4.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">多场景曝光</div>
            <div class="desc">
              打通百度产品矩阵<br />
              全方位多渠道曝光展现
            </div>
          </div>
        </div>
        <div class="out" style="right: -67%; bottom: 140px">
          <img
            src="http://gxbg.pangodso.com/file/aicaigou_img5.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">多线索全链路打通</div>
            <div class="desc">
              高精准度线索分发，从询价<br />
              到交易全链路闭环提高转化
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
        <div class="type">
          穿插在百度APP、百度首页、贴吧、百度手机浏览器等平台的资讯流中
        </div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == 0 }"
            @mouseenter="changeType(0)"
          >
            店铺首页pc端
          </div>
          <div
            :class="{ type: true, active: activeType == 1 }"
            @mouseenter="changeType(1)"
          >
            小程序店铺/商品页
          </div>
        </div>
        <div class="desc">
          <div class="desc_content" v-show="activeType == 0">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/aicaigou_img6.png"
                alt=""
              />
            </div>
          </div>
          <div class="desc_content" v-show="activeType == 1">
            <div class="item">
              <img
                class="img"
                src="http://gxbg.pangodso.com/file/aicaigou_img7.png"
                alt=""
              />
              <img
                class="mobile-img"
                src="http://gxbg.pangodso.com/file/aicaigou_img8.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {
      activeType: 1,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  methods: {
    changeType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 1200px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 100px;

  .content {
    width: 1200px;
    margin: 90px auto 0;
    display: flex;

    .types {
      .type {
        width: 250px;
        height: 70px;
        border: 1px solid #eaecee;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          &::after {
            display: block;
          }
        }

        &::after {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent transparent #5f84de;
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
        & + .type {
          margin-top: 30px;
        }
      }
      .active {
        color: $theme;
        background-color: #eaecee;
        box-shadow: 0 16px 16px rgba($color: $theme, $alpha: 0.11);

        &::after {
          display: block;
        }
      }
    }

    .desc {
      flex-grow: 1;
      margin-left: 40px;

      .desc_content {
        display: flex;
        animation: fadeIn 0.5s linear;

        .item {
          flex: 1;
          text-align: center;

          & + .item {
            margin-left: 50px;
          }
          img {
            max-width: 100%;
          }
          .mobile-img {
            display: none;
          }
          .title {
            font-size: 25px;
            margin-top: 50px;
          }
          .sub {
            width: 350px;
            margin: 0 auto;
            color: #6e7685;
            line-height: 26px;
            margin-top: 25px;
          }
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .float {
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .center {
      width: 80%;
    }
    .out {
      width: 50%;
      margin-bottom: 10px;
      position: static;
      flex-direction: column;
      align-items: center;

      .icon {
        width: 50px;
      }
      .text {
        margin-left: 0;

        .title {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
          line-height: 1.5;
        }
      }
    }
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 40px;
      flex-direction: column;

      .types {
        display: flex;

        .type {
          height: 50px;
          line-height: 50px;
          flex: 1;
          width: unset;
          font-size: 18px;

          & + .type {
            margin-top: 0;
          }
        }
        .active::after {
          top: unset;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%) rotate(90deg);
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 60px;

        .desc_content {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          max-width: 100% !important;
          flex-direction: row !important;

          .item {
            & + .item {
              margin-top: 0 !important;
              margin-left: 8px !important;
            }
            .img {
              display: none;
            }
            .mobile-img {
              display: block;
            }
            .title {
              font-size: 18px;
              margin-top: 20px;
            }
            .sub {
              width: auto;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    width: 1000px;

    .types .type {
      width: 200px;
      font-size: 20px;
    }
    .desc .desc_content .item {
      .title {
        font-size: 20px;
      }
      .sub {
        font-size: 14px;
      }
    }
  }
}
</style>
